<template>
  <div>
    <div
      v-if="!visible"
      class="p-2"
    >
      <button
        :class="btnClass"
        @click="visible = !visible"
      >
        {{ expandLabel }}
        <i class="fa fa-caret-down ml-1"></i>
      </button>
    </div>
    <div
      v-if="visible"
    >
      <slot></slot>
    </div>
    <div
      v-if="visible && !hideButtonOnExpand"
      class="p-2"
    >
      <button
        :class="btnClass"
        @click="visible = !visible"
      >
        {{ collapseLabel }}
        <i class="fa fa-caret-up ml-1"></i>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    btnClass: {
      type: String,
      default: 'btn btn-block btn-primary'
    },
    hideButtonOnExpand: {
      type: Boolean,
      default: false
    },
    defaultVisible: {
      type: Boolean,
      default: false
    },
    expandLabel: {
      type: String,
      default: 'Expand'
    },
    collapseLabel: {
      type: String,
      default: 'Collapse'
    }
  },
  data () {
    return {
      visible: this.defaultVisible
    }
  }
}
</script>